<template>
	<div>
		<div class='knd-graph-header'>Berichten over biolabs komen in golven</div>
		<div class='knd-graph-intro'>Tijdlijn van het aantal berichten over biolabs in de onderzochte Telegramgroepen. Hoe roder de stip, hoe groter het bereik van het bericht. Klik op een stip om het bericht te lezen.</div>
		<div class='knd-graph'>	
			<div class='knd-chart' ref='chart'></div>
			<div class='knd-tooltip hidden' @click='hideTooltip()' ref='tooltip'>
				<div class='knd-tt-kop'  v-html='message.datum + " - " + message.naam + ":"'></div>
				<div class='knd-tt-tekst'  v-html="message.tekst"></div>
				<div class='knd-tt-close'></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Biolabs from './biolabs.js';

	import './biolabs.scss'

	export default {
		name: 'Biolabs',
		data: function() {
			return {
				data: this.$store.state.messages,
				message: {
					"naam": null,
					"datum": null,
					"tekst": null
				}
			}
		},
		methods: {
			updateTooltip(info) {
				this.message = info;
				this.showTooltip();
			},

			showTooltip() {
				this.$refs.tooltip.classList.remove("hidden");
			},

			hideTooltip() {
				this.$refs.tooltip.classList.add("hidden");
			}
		},
		mounted: function() {
			let grafiek = new Biolabs()
				.container(this.$refs.chart)
				.callBacks({"updateTooltip": this.updateTooltip})
				.prepareSwarm(this.data)
				.render();
		}
	}
</script>